import {
  AuthenticatorContract,
  CachedCredentialsContract,
} from '@terra/shared-contracts-authenticator';
import { createTerraOrpcClient } from '@terra/shared-utils';

const SERVICE_NAME = 'ai';

export const authenticatorClient = createTerraOrpcClient({
  contract: AuthenticatorContract,
  serviceName: SERVICE_NAME,
});

export const cachedCredentialsClient = createTerraOrpcClient({
  contract: CachedCredentialsContract,
  serviceName: SERVICE_NAME,
});
